<div id="entity_list" class="flex flex-col gap-5 h-full min-h-0">
    <!-- Título -->
    <span *ngIf="title" class="text-3xl font-semibold w-full">{{ title }}</span>

    <!-- Input para filtrar -->
    <div class="w-full">
        <input id="filter"
            type="text"
            [formControl]="search"
            class="w-full px-3 py-4 border ring-1 rounded-md shadow-sm focus:outline-none focus:ring-2 ring-blue-500"
            placeholder="Escribir acá para filtrar" />
    </div>

    <!-- Lista de selección -->
    <ul class="w-full rounded-md divide-y overflow-y-auto flex-1 min-h-0">
        <li *ngFor="let entity of $search | async" (click)="selected(entity)" [ngClass]="entity.id == id ? 'bg-gray-200' : ''"
            class="flex items-center p-1 hover:bg-gray-300 cursor-pointer">
      <span [ngClass]="{'text-gray-500': entity.enabled!=undefined && !entity.enabled, 'text-black': entity.enabled==undefined || entity.enabled}"
          class="flex-1">
        {{  getNameFunction(entity) }}
      </span>
        </li>
    </ul>
</div>
